import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-review-item-value',
    templateUrl: './review-item-value.component.html',
    styleUrls: ['./review-item-value.component.scss'],
    standalone: false
})
export class ReviewItemValueComponent implements OnInit {
  @Input() value: any;

  constructor() {}

  simpleValueOutput: string;
  arrayValueOutput: any[];
  objectValueOutput: any;

  ngOnInit() {
    if (this.value !== undefined && this.value !== null) {
      if (typeof this.value === 'boolean') {
        this.simpleValueOutput = this.value ? 'Yes' : 'No';
      } else if (typeof this.value === 'string') {
        const val = this.value.trim().toUpperCase();
        if (val === 'Y' || val === 'TRUE') {
          this.simpleValueOutput = 'Yes';
        } else if (val === 'N' || val === 'FALSE') {
          this.simpleValueOutput = 'No';
        } else if (this.tryParseJSON(this.value)) {
          const json = JSON.parse(this.value);
          if (Array.isArray(json)) {
            this.arrayValueOutput = json;
          } else {
            this.objectValueOutput = json;
          }
        } else {
          this.simpleValueOutput = this.value;
        }
      } else {
        this.simpleValueOutput = this.value.toString();
      }
    }
  }

  objectKeys(item) {
    return Object.keys(item);
  }

  tryParseJSON(jsonString) {
    try {
      const o = JSON.parse(jsonString);

      // Handle non-exception-throwing cases:
      // Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
      // but... JSON.parse(null) returns null, and typeof null === "object",
      // so we must check for that, too. Thankfully, null is falsey, so this suffices:
      if (o && typeof o === 'object') {
        return o;
      }
    } catch (e) {}

    return false;
  }

  IsJsonString(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }
}
